var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePlatformIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5704_57589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 2.5L10 4.5L8 6.5L6 4.5L8 2.5Z",
    stroke: "#726C6C",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10.5L10 12.5L8 14.5L6 12.5L8 10.5Z",
    stroke: "#726C6C",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5L14 8.5L12 10.5L10 8.5L12 6.5Z",
    stroke: "#726C6C",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6.5L6 8.5L4 10.5L2 8.5L4 6.5Z",
    stroke: "#726C6C",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5704_57589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePlatformIcon);
export default __webpack_public_path__ + "static/media/profilePlatformIcon.62dee37c6eddbfa18b4b3600073c0e70.svg";
export { ForwardRef as ReactComponent };